import { client } from "../request";

export interface ConstructionType {
  id?: string;
  name: string;
}

export function getConstructionTypes(id?: string | number): Promise<ConstructionType[]> {
  return client.get("get_construction_types.php", { id });
}

export async function saveConstructionType(
  params: ConstructionType
): Promise<void> {
  const data = new FormData();
  if (params.id) {
    data.append("id", params.id);
  }
  data.append("name", params.name);

  await client.post("save_construction_type.php", data);
}

export async function deleteConstructionType(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);

  await client.post("delete_construction_type.php", data);
}
